import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query Users($id: Int!) {
  user(id: $id) {
    id
    role
    operatorTeam {
      activitySearchTeamIds
      activitySearchTeams
      requestTypePriorities {
        id
        channel {
          id
        }
        requestType{
          id
        }
      }
    }
    operatorTeamId
    overseerTeams {
      id
      name
    }
    name
    email
    fullName
    firstName
    lastName
    middleName
    displayName
    absenceReason
    avgVote
    logged
    ready
    banned
    avatarUrl
    sipUrl
    sipPassword
    ucceInfo {
      uccePeripheralId
      uccePeripheralFirstName
      uccePeripheralLastName
      uccePeripheralLogin
    }
    useExpress
    ctsUserId
    ldapUser
    ldapStatus
    external
  }
}`;

function getUserById({ id }) {
  return apollo.client.query({
    variables: { id: parseInt(id, 10) },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => ({ id, ...res.data.user }));
}

export default getUserById;
